export type RedirectConfig = { key: string; url: string }

/**
 * - `SHORT_URL`: resolves a short URL to its destination and redirects.
 * - `INVITATION`: resolves an invitation to its meeting URL and redirects.
 * - `SEAMLESS`: query-param-driven, analytics-routed redirect with no UI.
 */
export enum RedirectorVariant {
  SHORT_URL = 'short-url',
  INVITATION = 'invitation',
  SEAMLESS = 'seamless'
}

/**
 * Invitation key for the APWG meeting scheduler. Routed as the invitation
 * variant; selects the practice-level APWG invitation lookup.
 */
export const APWG_SCHEDULER_KEY = 'apwg'

/**
 * Resolves to a short URL via a short-url lookup.
 */
export type RedirectorShortUrlConfig = {
  variant: RedirectorVariant.SHORT_URL
  shortUrl: string
}

/**
 * Resolves to a meeting URL via an invitation lookup. {@link invitationKey}
 * selects which invitation to resolve (currently only
 * {@link APWG_SCHEDULER_KEY}).
 */
export type RedirectorInvitationConfig = {
  variant: RedirectorVariant.INVITATION
  invitationKey: string
}

/**
 * Redirects via a query-param-driven transition, optionally specifying multiple
 * redirect mappings and source information.
 */
export type RedirectorSeamlessTransitionConfig = {
  variant: RedirectorVariant.SEAMLESS
  config?: RedirectConfig[]
  selectedItem?: string
  source?: string
}

export type RedirectorProps =
  | RedirectorShortUrlConfig
  | RedirectorInvitationConfig
  | RedirectorSeamlessTransitionConfig
